import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { urlEndPoint } from 'src/app/common';
import { Tier3 } from 'src/app/models/obs/tier3';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';

@Component({
  selector: 'app-admtech-form',
  templateUrl: './admtech-form.component.html',
  styleUrl: './admtech-form.component.scss'
})
export class AdmtechFormComponent implements OnInit {

  formT3: FormGroup;
  t3: Tier3 = null;

  edit: boolean = false;
  idtier1: string = null;
  uploatedFile: File = null;
  filename: string = '';
  isUploadDir: boolean = false;

  URL: string = urlEndPoint;
  tags: string = null;

  constructor(
    private router: Router,
    private t3S: Tier3Service,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private uploadS: UploadfileService,
    private userLogService: UserLogService,
    private tokenStorage: TokenStorageService,
    private tematicsService: TematicService
  ) { }

  ngOnInit() {
    this.createForm();
    this.getT3();
    this.getTematics();
  }

  createForm() {
    this.formT3 = this.fb.group({
      id: [null],
      idtier1: [null],
      idtematic: ['', Validators.required],
      code: ['', Validators.required],
      version: ['', Validators.required],
      shorttitle: ['', Validators.required],
      longtitle: ['', Validators.required],
      summary: ['', Validators.required],
      detail: [null],
      publication: ['', Validators.required],
      img: [null],
      urlfile: [null],
      lastUpdated: ['', Validators.required],
      status: [],
      tags: []
    })
  }

  getT3() {
    const params = this.activedRoute.snapshot.params;
    if (params['id']) {
      this.t3S.getOne(params['id']).subscribe({
        next: res => {
          this.t3 = res['data'];
          this.verifiedImgDirectory();
          this.loadData();
          this.edit = true;
        },
        error: err => console.error(err)
      });
    } else if (params['idtier1']) {
      this.idtier1 = params['idtier1'];
      this.edit = false;
    }
  }

  verifiedImgDirectory() {
    if (this.t3.img != null) {
      (this.t3.img.substring(1, 7) === 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  loadData() {
    this.formT3.reset(this.t3);
  }

  onUpload() {
    let formData = new FormData();
    formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
    this.uploadS.uploadFile(formData).subscribe((res) => {
      this.filename = res['filename'];
      this.saveOrUpdate();
    });
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.formT3.get('img').setValue(e.target['result']);
    };
    reader.readAsDataURL(this.uploatedFile[0]);
  }

  save() {
    if (this.formT3.invalid) {
      console.log("Formulario inválido");
      return Object.values(this.formT3.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      (this.uploatedFile != null) ? this.onUpload() : this.saveOrUpdate();
    }
  }

  saveOrUpdate() {
    this.edit ? this.update(this.formT3.value.id, this.formT3.value) : this.create(this.formT3.value);
    this.router.navigate(['/adm/tecnologia/list']);
  }
  dataLog = {};
  create(t3: Tier3) {
    delete t3.id;
    t3.idtier1 = +this.idtier1;
    if (this.filename) { t3.img = '/uploads/' + this.filename; }
    this.t3S.create(t3).subscribe({
      next: res => {
        /* Inicio - crear log de actividad de usuario */
        if (res) {
          this.dataLog['iduser'] = this.tokenStorage.getUser().id;//el que esta realizando accion de crear
          this.dataLog['nameUser'] = this.tokenStorage.getUser().nombre;//Definimos el id del contenido que se esta creando 
          this.dataLog['idContent'] = res['data'].id;//Definimos el id del contenido que se esta creando 
          this.dataLog['nameComponent'] = 'Lista tecnologías emergentes';//determinamos si es figura, bilbiografia, seccion o subcion 
          this.dataLog['idtier3'] = res['data'].id;//determinamos a que campo pertence el contenido creado
          this.dataLog['action'] = 'creación';//definimos que accion esta realizando

          this.userLogService.createUserLog(this.dataLog).subscribe({
            next: res => { },
            error: err => console.error(err)
          })
        }
        /* Fin - crear log de actividad de usuario */
        console.log("res create: ", res)
      },
      error: err => { console.error(err) }
    });
  }

  update(id: string, t3: Tier3) {
    delete t3.id;
    if (this.filename) { t3.img = '/uploads/' + this.filename; }
    this.t3S.update(id, t3).subscribe({
      next: res => {
        /* Inicio - crear log de actividad de usuario */
        if (res) {
          this.dataLog['iduser'] = this.tokenStorage.getUser().id;//el que esta realizando accion de crear
          this.dataLog['nameUser'] = this.tokenStorage.getUser().nombre;//Definimos el id del contenido que se esta creando 
          this.dataLog['idContent'] = id;//Definimos el id del contenido que se esta creando 
          this.dataLog['nameComponent'] = 'Lista tecnologías emergentes';//determinamos si es figura, bilbiografia, seccion o subcion 
          this.dataLog['idtier3'] = id;//determinamos a que campo pertence el contenido creado
          this.dataLog['action'] = 'edicion';//definimos que accion esta realizando

          this.userLogService.createUserLog(this.dataLog).subscribe({
            next: res => { },
            error: err => console.error(err)
          })
        }
        /* Fin - crear log de actividad de usuario */
        console.log("res update: ", res)
      },
      error: err => { console.error(err) }
    });
  }

  campoNoValido(campo: string) {
    return this.formT3.get(campo).invalid && this.formT3.get(campo).touched;
  }
  /* Cargar data de tematic para el combo */
  tematics: any;
  getTematics() {
    this.tematicsService.getAll().subscribe({
      next: res => {
        this.tematics = res['data'];
      },
      error: err => {
        console.log(err['msg']);
      }
    });
  }

}
